<template>
  <div class="group-manage conmon-top" style="height: 100%;">
    <el-container style="overflow-x: hidden;">
      <!--右侧列表-->
      <div class="table-first-style" style="padding: 0;width: 100%; overflow-x: hidden;">
        <div class="base-input ovf-hd" style="margin-bottom: 10px; overflow-x: hidden;">
          <el-row class="search-title">
            <el-col :span="4" class="table-title">
              <i class="el-icon-search" style="font-weight: bold"></i>
              <span class="order-list-search-span" v-if="!$route.query.id">新建群组</span>
              <span class="order-list-search-span" v-if="$route.query.id">编辑群组</span>
            </el-col>
          </el-row>
          <!-- 查询区域 -->
          <!--高级查询-->
          <el-row class="search-content" style="min-height:210px;height:auto;line-height: 0">
            <div style="text-align: left;padding: 20px 0" class="hei-ser">
              <el-col style="margin: -20px 0 20px;">
                <span style="margin-left: 20px">
                  <i style="opacity: 0;margin-right: 1px;">* </i>所属分组：</span>
                <el-select class="common-search-formtype" style="margin-right: 13px" v-model="group_id" placeholder="请选择所属分组" clearable>
                  <el-option v-for="item in queryGroups" :key="item.id" :label="item.name" :value="item.id">
                  </el-option>
                </el-select>
              </el-col>
              <el-col style="margin: 0 0 20px;">
                <span style="margin-left: 20px;">
                  <i style="color: red;margin-right: 1px;">* </i>群组名称：</span>
                <el-input class="common-search-formtype" placeholder="群组名称" v-model="newGroupName"></el-input>
              </el-col>
              <el-col style="margin: 0 0 20px;" v-if="!$route.query.id">
                <span style="margin-left: 20px;">
                  <i style="color: red;margin-right: 1px;">* </i>群组类型：</span>
                <el-radio-group class="choGroup" @change="toggleGroup" v-model="group_type" style="margin-top: 2px;">
                  <el-radio :label="2">静态群组</el-radio>
                  <el-radio :label="1">动态群组</el-radio>
                </el-radio-group>
              </el-col>
              <el-col style="text-align: left;padding-bottom: 10px;margin-top: 10px;">
                <span class="aud-query-add-sapn">
                  <i style="color: red;margin-right: 1px;">* </i>
                  <span v-if="group_type === 1">群组条件</span>
                  <span v-if="group_type === 2">添加受众</span>：
                </span>
                <higher-search-audiences class="common-search-formtype aud-manage-higher-search group-item-style" v-bind:allRelationship="allRelationship" :forSonTerms="forSonTerms" @change="getAllTerms" :isAnalyse="isAnalyse">
                </higher-search-audiences>
              </el-col>
              <el-button type="primary" :disabled="isDisabled" :class="isDisabled ? 'disabled' : 'add-btn'" class="add-btn" style="margin-right: 32px" @click="saveQuery">保存</el-button>
              <el-button type="primary" class="add-btn" style="margin-right: 10px;margin-bottom: 20px;" @click="preView">预览</el-button>
            </div>
          </el-row>
        </div>
        <el-row class="search-title common-table-top" style="padding-right:0">
          <el-col :span="6" class="table-title name-wrapper">
            <i class="el-icon-document" style="font-weight: bold;"></i>
            <span v-text="useName"></span>
          </el-col>
        </el-row>
        <!--客户列表-->
        <el-table class="audiences-table-content" v-loading="loading" :data="tableData" border>
          <template slot="empty">
            <div class="newTableEmpty">没有更多数据了</div>
          </template>
          <el-table-column :sortable="data.isSort" min-width="160" :label="data.label" v-for="data in headerList" :key="data.identity" :prop="data.identity">
            <template slot-scope="scope">
              <img v-if="data.identity == 'avatar'" style="width: 32px; height: 32px; display: block; border-radius: 50%; text-align: left; float: left; margin-right: 10px;" :src="scope.row[data.identity] | showImgUrl" />
              <div v-else :class="isSafari ? 'aud-show-divs' : 'aud-show-div'">
                <span :title="scope.row[data.identity]">{{ scope.row[data.identity] }}</span>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="table-foot" style="text-align: right">
          <el-pagination class="table-foot-pagination" background @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-size="limit" :current-page="page" layout="total, prev, pager, next, jumper" :total="totalCount">
          </el-pagination>
        </div>
      </div>
    </el-container>
  </div>
</template>

<script>
import { getGroupTypeList, deleteGroupType, getGroupList, editGroupType, deleteGroup, getCustomerList } from '@/api/customer.js'
import { getCusTypes, getCusEventList, getCustomerSources, getCusStageList, getAudGroupGroupList, getAudGroupList, addAudGroup, getAudiencesList, getAudListShowSix, getCusAttrList, getAudGroupDetail, audEditGroup } from '@/api/set.js'
import HigherSearchAudiences from './../common/higher-search-audiences.vue'
import { judgeIsEmpty } from '../../api/publicMethods'
import { setTimeout } from 'timers'
import { higherAduRelateReversalOne, higherAduRelateOpsOne, higherAduRelateOpsFour, higherAduRelateOpsFive } from '../common/constant'
export default {
  name: 'audGroupManageAdd',
  data () {
    return {
      isAnalyse: false,
      isDis: false,
      rowList: [],
      source: [],
      stages: [],
      isSafari: false,
      headerList: [],
      useName: '',
      group_type: 1,
      loading: false,
      group_id: '',
      queryGroups: [],
      tableData: [],
      customerData: [],
      limit: 10,
      totalCount: 0,
      adddialog: false,
      editdialog: false,
      addForm: {
        name: ''
      },
      editForm: {
        name: ''
      },
      addLabelWidth: '80px',
      dialogType: 0,
      editId: '',
      editGroupTypeId: '',
      page: 1,
      hide: true,
      closeChoose: '收起筛选',
      search: {
        allRelationship: 'and',
        termsGroup: [
          {
            inOperator: 'and',
            terms: [
              {
                attr: 'attr',
                attr_label: '真实姓名',
                relationship: '',
                // relationOptions: [
                //   {
                //     value: 'equal',
                //     label: '等于'
                //   }, {
                //     value: 'not_equal',
                //     label: '不等于'
                //   }, {
                //     value: 'contain',
                //     label: '包含'
                //   }, {
                //     value: 'empty',
                //     label: '为空'
                //   },
                //   {
                //     value: 'not_empty',
                //     label: '不为空'
                //   }
                // ],
                value: null,
                startValue: '',
                options: [],
                option: null,
                endValue: '',
                // original_id: null,
                // eventAttributeList: [],
                // activitiesTwo: [],
                // templatesTwo: [],
                // wepageTwo: [],
                // eventAttrOptions: [
                //   {
                //     attributeContent: '',
                //     relationOptions: [],
                //     sources: [],
                //     eventAttrValueOptions: [],
                //     attributeRelation: '',
                //     attr_type: '',
                //     attrValTimeStart: '',
                //     attrValTimeEnd: '',
                //     attributeValueStart: '',
                //     attributeValueEnd: '',
                //     attributeValue: ''
                //   }
                // ],
                // optionOther: null,
                // qrcodeOptions: null,
                // templateOption: null,
                // qrcode: null,
                // offline_qrcode: null,
                // template_id: null,
                // leave_word: null,
                // public_reply_type_all: {
                //  reply_type: '不限',
                //  reply_content: ''
                // },
                // eventLimitTime: false,
                // eventLimitTimes: false,
                // eventLimitAttr: false,
                // eventTimeRelation: '',
                // eventDateStart: '',
                // eventDateEnd: '',
                // happenedTimes: '',
                // start_time: '',
                // end_time: '',
                selectedOptions: ['attr', '']
              }
            ]
          }
        ]
      },
      searchs: {},
      groupNameTmp: '',
      groupName: '',
      newGroupName: '',
      groups: [],
      deleteArrayIds: [],
      checkAll: true,
      groupsType: {
        1: '动态群组',
        2: '静态群组'
      },
      createGroupType: 0,
      groupTypeIndex: 0,
      isDisabled: false,
      lastId: 0,
      allTerms: {},
      allRelationship: 'and',
      forSonTerms: [
        {
          inOperator: 'and',
          terms: [
            {
              attr: 'attr',
              attr_label: '真实姓名',
              relationship: '',
              relationOptions: [
                {
                  value: 'equal',
                  label: '等于'
                }, {
                  value: 'not_equal',
                  label: '不等于'
                }, {
                  value: 'contain',
                  label: '包含'
                }, {
                  value: 'empty',
                  label: '为空'
                },
                {
                  value: 'not_empty',
                  label: '不为空'
                }
              ],
              startValue: '',
              endValue: '',
              value: null,
              original_id: null,
              eventAttributeList: [],
              options: [],
              option: [],
              eventAttrOptions: [
                {
                  attributeContent: '',
                  relationOptions: [],
                  sources: [],
                  eventAttrValueOptions: [],
                  attributeRelation: '',
                  attr_type: '',
                  attrValTimeStart: '',
                  attrValTimeEnd: '',
                  attributeValueStart: '',
                  attributeValueEnd: '',
                  attributeValue: ''
                }
              ],
              eventLimitTime: false,
              eventLimitTimes: false,
              eventLimitAttr: false,
              eventTimeRelation: '',
              eventDateStart: '',
              eventDateEnd: '',
              start_time: '',
              end_time: '',
              selectedOptions: ['attr', '']
            }
          ]
        }
      ],
      result: [],
      len: 0
    }
  },
  computed: {
    Newitems () {
      let _this = this
      let Newitems = []
      if (_this.groupName === '') {
        return
      }
      _this.groups.map(function (item) {
        if (item.name.search(_this.groupName) != -1) {
          Newitems.push(item)
        }
      })
      return Newitems
    }
  },
  components: {
    'higher-search-audiences': HigherSearchAudiences
  },
  methods: {
    // 请求初始来源
    loadSource () {
      getCustomerSources(1, 0, '').then((res) => {
        if (res.data.code == 200) {
          for (let one of res.data.result.list) {
            this.source[one.id] = one.name
          }
        }
      })
    },
    // 获取相对关系
    getRelationOptionsWay(type, attrType){
      console.log(type+'//'+attrType)
      // console.log(higherAduRelateOpsFive() , '//'+attrType)
      if(type === 'address' || type === 'source') {
        return higherAduRelateOpsFive()
      }
      if (type === 'source_content' || type === 'serial_number') {
        return  higherAduRelateOpsOne()
      }
      if (type !== 'source' || type !== 'source_content' || type !== 'serial_number') {
        if (attrType === 'txt') {
          return higherAduRelateReversalOne()
        }
        if (attrType === 'money') {
          return higherAduRelateOpsFour()
        }
        if (attrType === 'number') {
          return higherAduRelateOpsFive()
        }
        if (attrType === 'dictionary') {
          return [
            {
              value: 'equal',
              label: '等于'
            }
          ]
        }
      }
    },
    // 请求受众等级
    loadStage (modelId) {
      if (!modelId) {
        modelId = this.$route.params.id
      }
      getCusStageList(modelId).then((res) => {
        if (res.data.code == 200) {
          res.data.result.unshift({
            id: 0,
            name: '未知'
          })
          for (let one of res.data.result) {
            this.stages[one.id] = one.name
          }
        }
      })
    },
    // 获取列表名字
    getAudiencesName (modelId, to) {
      getCusTypes().then((res) => {
        if (res.data.code == 200) {
          this.modelData = res.data.result
          let id = this.$route.params.id
          let realId = this.$route.query.id
          for (let item of this.modelData) {
            if (item.id == id) {
              this.useName = item.name + '列表'
              let arr = to.meta.routeArr
              if (realId) {
                arr[1].name = item.name + '编辑群组'
              } else {
                arr[1].name = item.name + '新建群组'
              }
              this.$store.state.breadcrumb = to.meta.routeArr
            }
          }
        }
      })
    },
    // 切换群组类型
    toggleGroup (val) {
      console.log('01', val, this.group_type)
      this.forSonTerms = [
        {
          inOperator: 'and',
          terms: [
            {
              attr: 'attr',
              attr_label: '真实姓名',
              relationship: '',
              relationOptions: [
                {
                  value: '=',
                  label: '等于'
                }, {
                  value: '!=',
                  label: '不等于'
                }, {
                  value: 'contain',
                  label: '包含'
                }, {
                  value: 'empty',
                  label: '为空'
                },
                {
                  value: 'not empty',
                  label: '不为空'
                }
              ],
              startValue: '',
              endValue: '',
              value: null,
              original_id: null,
              eventAttributeList: [],
              options: [],
              option: [],
              eventAttrOptions: [
                {
                  attributeContent: '',
                  relationOptions: [],
                  sources: [],
                  eventAttrValueOptions: [],
                  attributeRelation: '',
                  attr_type: '',
                  attrValTimeStart: '',
                  attrValTimeEnd: '',
                  attributeValueStart: '',
                  attributeValueEnd: '',
                  attributeValue: ''
                }
              ],
              eventLimitTime: false,
              eventLimitTimes: false,
              eventLimitAttr: false,
              eventTimeRelation: '',
              eventDateStart: '',
              eventDateEnd: '',
              start_time: '',
              end_time: '',
              selectedOptions: ['attr', '']
            }
          ]
        }
      ]
      this.load()
    },
    // 获取所属分组名字
    getAudGroupGroupLists () {
      let modelId = this.$route.params.id
      getAudGroupGroupList(modelId, '').then((res) => {
        if (res.data.code == 200) {
          // res.data.result.unshift({
          //   id: 0,
          //   name: '全部'
          // })
          this.queryGroups = res.data.result
        }
      })
    },
    // 获取子组件的查询条件
    getAllTerms (value) {
      this.allTerms = value
      this.searchs = value
      console.log('getAllTerms', value)
      console.log('101', value, this.allTerms)
    },
    // 添加群组
    saveQuery () {
      // 判断是否为空
      if (!judgeIsEmpty(this.allTerms.termsGroup)) {
        return
      }
      let id = this.$route.query.id
      if (this.allTerms.termsGroup.length === 1) {
        console.log('sssss', this.allTerms)
        if (this.allTerms.termsGroup[0].terms[0].value == null && this.allTerms.allRelationship !== 'and') {
          _g.toastMsg('error', '请选择条件')
          return
        }
      }
      let termsSend = {}
      if (!id) {
        console.log('2021', this.allTerms)
        termsSend = JSON.parse(JSON.stringify(this.allTerms))
      } else {
        console.log('2020', this.searchs)
        termsSend = this.searchs
      }
      for (let item of termsSend.termsGroup) {
        for (let one of item.terms) {
          // 删除无用属性
          // 判断是否属性attr
          if (one.selectedOptions[0] === 'attr') {
            delete one.eventAttrOptions
            delete one.eventDateEnd
            delete one.eventDateStart
            delete one.eventTimeRelation
            delete one.eventLimitAttr
            delete one.eventLimitTime
            delete one.eventLimitTimes
          }
          // 判断是否事件event
          if (one.selectedOptions[0] === 'event') {
            if (one.eventLimitTime === true) {
              one.eventDateStart = this.evalTime(one.eventDateStart)
              one.eventDateEnd = this.evalTime(one.eventDateEnd)
            }
            one.secAttr = one.selectedOptions[2]
            for (let o of one.eventAttrOptions) {
              delete o.sources
              // delete o.relationOptions
              delete o.eventAttrValueOptions
            }
            delete one.startValue
            delete one.endValue
            // delete one.relationship
          } else {
            one.secAttr = one.selectedOptions[1].split('@')[0]
          }
          // 判断是否群组group/标签aud_portary
          if (one.selectedOptions[0] === 'group' || one.selectedOptions[0] === 'aud_portary') {
            delete one.eventAttrOptions
            delete one.eventDateEnd
            delete one.eventDateStart
            delete one.eventLimitAttr
            delete one.eventLimitTime
            delete one.eventLimitTimes
          }
          let firAttr = one.selectedOptions[0]
          one.attr = firAttr
          delete one.original_id
          delete one.option
          delete one.relationOptions
          delete one.eventAttributeList
          delete one.end_time
          delete one.start_time
          delete one.attr_label
          delete one.eventTimeRelation
        }
      }
      // 防止重复点击
      this.isDisabled = true
      let modelId = this.$route.params.id
      if (!id) {
        // 添加
        if(this.group_id === '') {
          this.group_id = 0
        }
        addAudGroup(modelId, this.newGroupName, this.group_type, termsSend, this.group_id).then((res) => {
          if (res.data.code == 200) {
            this.isDisabled = false
            _g.toastMsg('success', res.data.message)
            router.push({ path: '/home/audiences-group-manage/' + modelId })
          } else {
            this.isDisabled = false
            _g.toastMsg('error', res.data.message)
          }
        })
      } else {
        // 编辑
        console.log('1020', termsSend)
        let data = {
          id: this.$route.query.id,
          modelId: modelId,
          type: this.$route.query.type,
          name: this.newGroupName,
          groupId: this.group_id || 0,
          search: termsSend
        }
        audEditGroup(data).then((res) => {
          if (res.data.code == 200) {
            _g.toastMsg('success', res.data.message)
            router.push({ path: '/home/aud-group-manage-detail/' + modelId + '?id=' + id + '&type=' + this.$route.query.type })
            this.editDialog = false
          } else {
            _g.toastMsg('error', res.data.message)
            this.editDialog = false
          }
        })
      }
    },
    // 解析时间
    evalTime (time) {
      let date = new Date(time)
      let year = date.getFullYear()
      let mon = (date.getMonth() + 1) < 10 ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1)
      let day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
      let h = date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
      let m = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
      let s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
      return year + '-' + mon + '-' + day + ' ' + h + ':' + m + ':' + s
    },
    // 预览
    preView () {
      console.log('预览query004', this.allTerms)
      // 判断是否为空
      if (!judgeIsEmpty(this.allTerms.termsGroup)) {
        return
      }
      let termsSend = JSON.parse(JSON.stringify(this.allTerms))
      for (let item of termsSend.termsGroup) {
        for (let one of item.terms) {
          // 删除无用属性
          // 判断是否属性attr
          if (one.selectedOptions[0] === 'attr') {
            delete one.eventAttrOptions
            delete one.eventDateEnd
            delete one.eventDateStart
            delete one.eventTimeRelation
          }
          // 判断是否事件event
          if (one.selectedOptions[0] === 'event') {
            if (one.eventLimitTime === true) {
              one.eventDateStart = this.evalTime(one.eventDateStart)
              one.eventDateEnd = this.evalTime(one.eventDateEnd)
            }
            one.secAttr = one.selectedOptions[2]
            if (one.eventLimitAttr === true) {
              for (let o of one.eventAttrOptions) {
                delete o.sources
                // delete o.relationOptions
                delete o.eventAttrValueOptions
              }
            }
            delete one.startValue
            delete one.endValue
          } else {
            one.secAttr = one.selectedOptions[1].split('@')[0]
          }
          // 判断是否群组group/标签aud_portary
          if (one.selectedOptions[0] === 'group' || one.selectedOptions[0] === 'aud_portary') {
            delete one.eventAttrOptions
            delete one.eventDateEnd
            delete one.eventDateStart
          }
          let firAttr = one.selectedOptions[0]
          one.attr = firAttr
          // delete one.eventLimitAttr
          // delete one.eventLimitTime
          delete one.eventLimitTimes
          delete one.original_id
          delete one.option
          delete one.relationOptions
          delete one.eventAttributeList
          delete one.end_time
          delete one.start_time
          delete one.attr_label
          delete one.eventTimeRelation
        }
      }
      this.search = termsSend
      let modelId = this.$route.params.id
      this.loadSix(modelId)
    },
    // 处理分页
    handleSizeChange (val) {
      this.limit = val
      this.loadSix()
    },
    handleCurrentChange (page) {
      this.page = page
      this.loadSix()
    },
    // 加载属性取前六个的列表（常用）
    loadSix (modelId) {
      if (!modelId) {
        modelId = this.$route.params.id
      }
      let rowList = []
      getAudListShowSix(modelId).then((audListShowSixRes) => {
        if (audListShowSixRes.data.code == 200) {
          getCusAttrList(modelId).then((resp) => {
            if (resp.data.code == 200) {
              let data = resp.data.result
              let normal = []
              let notNormal = []
              for (let attr of data) {
                if (attr.isNormal === 0) {
                  notNormal.push(attr)
                } else {
                  normal.push(attr)
                }
              }
              // 总的设置列属性
              let arr = JSON.parse(audListShowSixRes.data.result.fields)
              for (let a of arr) {
                for (let item of normal) {
                  if (item.identity === a.identity) {
                    a.name = item.name
                  }
                }
              }
              // 处理发给后台的表头
              for (let one of arr) {
                if (one.isChecked === 1) {
                  rowList.push(one)
                }
              }
              this.rowList = rowList
              this.load(modelId)
            }
          })
        }
      })
    },
    // 加载群组列表
    load () {
      this.loading = true
      let modelId = this.$route.params.id
      getAudiencesList(this.page, this.limit, this.search, modelId, this.rowList, null).then((res) => {
        if (res.data.code == 200) {
          this.headerList = res.data.result.header
          this.tableData = res.data.result.list
          this.totalCount = res.data.result.total
          this.openLoading()
        } else {
          this.totalCount = 0
          this.tableData = []
          this.headerList = []
          this.loading = false
        }
      })
    },
    // 获取群组
    getGroup (item) {
      let modelId = this.$route.params.id
      getAudGroupList(modelId, 1, 1000000000, '', '').then((res) => {
        // 获取群组分组
        getAudGroupGroupList(modelId, '').then((respo) => {
          if (respo.data.code == 200) {
            // 设置分组
            respo.data.result.unshift({
              id: 0,
              name: '全部'
            })
            for (let item of respo.data.result) {
              item.children = []
              item.label = item.name
              item.value = item.id
            }
            // 普通分组群组
            for (let one of res.data.result.list) {
              for (let item of respo.data.result) {
                if (one.groupId == item.id) {
                  item.children.push({
                    label: one.name,
                    value: one.id
                  })
                }
              }
            }
            // 全部分组群组
            respo.data.result[0].children = []
            for (let one of res.data.result.list) {
              respo.data.result[0].children.push({
                label: one.name,
                value: one.id,
              })
            }
            item.option = respo.data.result
            item.options = respo.data.result
            console.log('aa', item.option)
          }
        })
      })
    },
    // 解析是动态群组编辑还是静态群组编辑
    editWhat () {
      let that = this
      let modelId = this.$route.params.id
      let id = this.$route.query.id
      let type = this.$route.query.type
      let rowList = []
      if (id) {
        this.group_type = parseInt(type)
        // 动态群组
        if (type == 1) {
          // 获取rowList
          getAudListShowSix(modelId).then((audListShowSixRes) => {
            if (audListShowSixRes.data.code == 200) {
              getCusAttrList(modelId).then((resp) => {
                if (resp.data.code == 200) {
                  let data = resp.data.result
                  let normal = []
                  let notNormal = []
                  for (let attr of data) {
                    if (attr.isNormal === 0) {
                      notNormal.push(attr)
                    } else {
                      normal.push(attr)
                    }
                  }
                  // 总的设置列属性
                  let arr = JSON.parse(audListShowSixRes.data.result.fields)
                  for (let a of arr) {
                    for (let item of normal) {
                      if (item.identity === a.identity) {
                        a.name = item.name
                      }
                    }
                  }
                  // 处理发给后台的表头
                  for (let one of arr) {
                    if (one.isChecked === 1) {
                      rowList.push(one)
                    }
                  }
                  getAudGroupDetail(id, '', '', 1, 10, 1, rowList, modelId).then(async (res) => {
                    if (res.data.code == 200) {
                      const { userGroup } = res.data.result
                      const { group } = userGroup
                      let query = JSON.parse(group.query)
                      console.log(query, 'group.query')
                      let qur = JSON.parse(JSON.stringify(group.query))
                      let qurs = JSON.parse(JSON.stringify(group.query))
                      this.search = JSON.parse(qur)
                      this.searchs = JSON.parse(qur)
                      this.$nextTick(() => {
                        this.group_id = group.groupId === 0 ? '' : group.groupId
                        this.newGroupName = group.name
                      })
                      // 加载客户
                      getAudiencesList(this.page, this.limit, this.search, modelId, rowList, null).then((res) => {
                        if (res.data.code == 200) {
                          this.headerList = res.data.result.header
                          this.tableData = res.data.result.list
                          this.totalCount = res.data.result.total
                          this.openLoading()
                        }
                      })

                      // 处理下查询条件回显
                      for (let one of query.termsGroup) {
                        for (let item of one.terms) {
                          item.options = []
                          item.option = []
                          // 属性
                          if (item.attr === 'attr') {
                            // 不是等级与来源
                            if (item.selectedOptions[1].split('@')[0] !== 'stage_id' && item.selectedOptions[1].split('@')[0] !== 'source_id') {
                              getCusAttrList(modelId).then((resa) => {
                                if (resa.data.code == 200) {
                                  for (let a of resa.data.result) {
                                    if (item.secAttr == a.identity) {
                                      item.options = a.options
                                      // item.option = JSON.parse(a.options)
                                      if (item.options !== '') {
                                        item.option = JSON.parse(item.options)
                                      }
                                      console.log('item.option', item.option)
                                    }
                                  }
                                }
                              })
                            }
                            // 等级
                            if (item.selectedOptions[1].split('@')[0] === 'stage_id') {
                              getCusStageList(modelId).then((res) => {
                                item.option = [
                                  {
                                    name: '未知等级',
                                    id: 0
                                  }
                                ]
                                for (let a of res.data.result) {
                                  item.option.push({
                                    name: a.name,
                                    id: a.id
                                  })
                                }
                              })
                            }
                            // 来源
                            if (item.selectedOptions[1].split('@')[0] === 'source_id') {
                              getCustomerSources(1, 10000, '').then((resb) => {
                                item.option = []
                                for (let b of resb.data.result.list) {
                                  item.option.push({
                                    name: b.name,
                                    id: b.id
                                  })
                                }
                              })
                            }
                            // 相对关系
                            // 文本
                            if (item.selectedOptions[1].split('@')[1] === 'input') {
                              item.relationOptions = [
                                {
                                  value: 'equal',
                                  label: '等于'
                                }, {
                                  value: 'not_equal',
                                  label: '不等于'
                                }, {
                                  value: 'contain',
                                  label: '包含'
                                }, {
                                  value: 'not_contain',
                                  label: '不包含'
                                }, {
                                  value: 'empty',
                                  label: '为空'
                                },
                                {
                                  value: 'not_empty',
                                  label: '不为空'
                                }
                              ]
                            }
                            // 单个选择列表
                            if (item.selectedOptions[1].split('@')[1] === 'select') {
                              item.relationOptions = [
                                {
                                  value: 'equal',
                                  label: '等于'
                                }, {
                                  value: 'not_equal',
                                  label: '不等于'
                                }, {
                                  value: 'empty',
                                  label: '为空'
                                },
                                {
                                  value: 'not_empty',
                                  label: '不为空'
                                }
                              ]
                            }
                            // 字典
                            if (item.selectedOptions[1].split('@')[1] === 'dict') {
                              item.relationOptions = [
                                {
                                  value: 'equal',
                                  label: '等于'
                                }, {
                                  value: 'not_equal',
                                  label: '不等于'
                                }, {
                                  value: 'empty',
                                  label: '为空'
                                },
                                {
                                  value: 'not_empty',
                                  label: '不为空'
                                }
                              ]
                            }
                            // 时间
                            if (item.selectedOptions[1].split('@')[1] === 'datePicker' || item.selectedOptions[1].split('@')[1] === 'dateTimePicker') {
                              item.relationOptions = [
                                {
                                  value: 'equal',
                                  label: '等于'
                                }, {
                                  value: 'lt',
                                  label: '早于'
                                }, {
                                  value: 'gt',
                                  label: '晚于'
                                }, {
                                  value: 'gtele',
                                  label: '区间'
                                }, {
                                  value: 'empty',
                                  label: '为空'
                                }, {
                                  value: 'not_empty',
                                  label: '不为空'
                                }
                              ]
                            }
                            // 地址
                            if (item.selectedOptions[1].split('@')[1] === 'addressPicker') {
                              item.relationOptions = [
                                {
                                  value: 'equal',
                                  label: '等于'
                                }, {
                                  value: 'not_equal',
                                  label: '不等于'
                                }, {
                                  value: 'empty',
                                  label: '为空'
                                },
                                {
                                  value: 'not_empty',
                                  label: '不为空'
                                }
                              ]
                            }
                            // 多个选择列表
                            if (item.selectedOptions[1].split('@')[1] === 'multipleSelect') {
                              item.relationOptions = [
                                {
                                  value: 'contain',
                                  label: '包含'
                                }, {
                                  value: 'not_contain',
                                  label: '不包含'
                                }, {
                                  value: 'empty',
                                  label: '为空'
                                },
                                {
                                  value: 'not_empty',
                                  label: '不为空'
                                }
                              ]
                            }
                            // 数值
                            if (item.selectedOptions[1].split('@')[1] === 'number') {
                              item.relationOptions = [
                                {
                                  value: 'equal',
                                  label: '等于'
                                }, {
                                  value: 'not_equal',
                                  label: '不等于'
                                }, {
                                  value: 'gt',
                                  label: '大于'
                                }, {
                                  value: 'lt',
                                  label: '小于'
                                }, {
                                  value: 'gtele',
                                  label: '区间'
                                }
                              ]
                            }
                            // 关联模型
                            if (item.selectedOptions[1].split('@')[1] === 'model') {
                              item.relationOptions = [
                                {
                                  value: 'contain',
                                  label: '包含'
                                }, {
                                  value: 'not_contain',
                                  label: '不包含'
                                }, {
                                  value: 'empty',
                                  label: '为空'
                                },
                                {
                                  value: 'not_empty',
                                  label: '不为空'
                                }
                              ]
                            }
                          }
                          // 事件
                          if (item.attr === 'event') {
                            item.relationOptions = [] // 相对关系回显方法
                            item.eventAttributeList = []
                            item.eventTimeRelation = item.relationship

                            // 当返回的限制次数 或者区间不为0时
                            if (item.happenedTimes > 0 || item.happenedTimesStart > 0) {
                              item.eventLimitTimes = true
                            } else {
                              item.eventLimitTimes = false
                            }
                            if (item.eventDateStart !== '' && item.eventDateStart) {
                              item.eventLimitTime = true
                            } else {
                              item.eventLimitTime = false
                            }
                            if (item.eventAttrOptions[0].attributeValue !== '') {
                              item.eventLimitAttr = true
                            } else {
                              item.eventLimitAttr = false
                            }
                            console.log(item.eventAttrOptions, 'item.eventAttrOptions')
                            for (let c of item.eventAttrOptions) {
                              // 相对关系回显
                              c.relationOptions = that.getRelationOptionsWay(c.attr_identity, c.attr_type)
                              c.sources = []
                              // getCusEventList(1, 0, '').then((resa) => {
                              //   for (let d of resa.data.result.list) {
                              //     if (item.secAttr === d.identity) {
                              //       let arr = JSON.parse(d.attr)
                              //       for (let yi of arr) {
                              //         if (c.attributeContent === yi.attr_identity) {
                              //           c.attr_type = yi.attr_type
                              //           c.attr_identity = yi.attr_identity
                              //         }
                              //       }
                              //       item.eventAttributeList = arr
                              //       console.log(arr, 'arr22222')
                              //     }
                              //   }
                              // })
                              c.attributeContent = c.attr_identity
                              const resa = await getCusEventList(1, 0, '')


                              for (let d of resa.data.result.list) {
                                if (item.secAttr === d.identity) {
                                  let arr = JSON.parse(d.attr)
                                  for (let yi of arr) {
                                    if (c.attributeContent === yi.attr_identity) {
                                      c.attr_type = yi.attr_type
                                      c.attr_identity = yi.attr_identity
                                    }
                                  }
                                  item.eventAttributeList = arr
                                }
                              }

                              // 事件限制属性相对关系
                              if (c.attributeContent === 'source') {
                                c.relationOptions = [
                                  {
                                    value: 'equal',
                                    label: '等于'
                                  },
                                  {
                                    value: 'not_equal',
                                    label: '不等于'
                                  },
                                  {
                                    value: 'empty',
                                    label: '为空'
                                  },
                                  {
                                    value: 'not_empty',
                                    label: '不为空'
                                  }
                                ]
                              }
                              if (c.attributeContent === 'source_content' || c.attributeContent === 'serial_number') {
                                c.relationOptions = [
                                  {
                                    value: 'equal',
                                    label: '等于'
                                  },
                                  {
                                    value: 'not_equal',
                                    label: '不等于'
                                  },
                                  {
                                    value: 'empty',
                                    label: '为空'
                                  },
                                  {
                                    value: 'not_empty',
                                    label: '不为空'
                                  },
                                  {
                                    value: 'contain',
                                    label: '包含'
                                  },
                                  {
                                    value: 'not_contain',
                                    label: '不包含'
                                  }
                                ]
                              }
                              if (c.attributeContent !== 'source' || c.attributeContent !== 'source_content' || c.attributeContent !== 'serial_number') {
                                if (c.attr_type === 'txt') {
                                  c.relationOptions = [
                                    {
                                      value: 'equal',
                                      label: '等于'
                                    },
                                    {
                                      value: 'not_equal',
                                      label: '不等于'
                                    },
                                    {
                                      value: 'contain',
                                      label: '包含'
                                    },
                                    {
                                      value: 'not_contain',
                                      label: '不包含'
                                    },
                                    {
                                      value: 'empty',
                                      label: '为空'
                                    },
                                    {
                                      value: 'not_empty',
                                      label: '不为空'
                                    }
                                  ]
                                }
                                if (c.attr_type === 'money') {
                                  c.relationOptions = [
                                    {
                                      value: 'equal',
                                      label: '等于'
                                    },
                                    {
                                      value: 'not_equal',
                                      label: '不等于'
                                    },
                                    {
                                      value: 'gt',
                                      label: '大于'
                                    },
                                    {
                                      value: 'gte',
                                      label: '大于等于'
                                    },
                                    {
                                      value: 'lt',
                                      label: '小于'
                                    },
                                    {
                                      value: 'lte',
                                      label: '小于等于'
                                    },
                                    {
                                      value: 'gtele',
                                      label: '区间'
                                    }
                                  ]
                                }
                                if (c.attr_type === 'number') {
                                  c.relationOptions = [
                                    {
                                      value: 'equal',
                                      label: '等于'
                                    },
                                    {
                                      value: 'not_equal',
                                      label: '不等于'
                                    },
                                    {
                                      value: 'empty',
                                      label: '为空'
                                    },
                                    {
                                      value: 'not_empty',
                                      label: '不为空'
                                    }
                                  ]
                                }
                                if (c.attr_type === 'dictionary') {
                                  c.relationOptions = [
                                    {
                                      value: 'equal',
                                      label: '等于'
                                    }
                                  ]
                                }
                              }
                              // 属性来源限制数据
                              if (c.attr_identity === 'source') {
                                getCustomerSources(1, 10000, '').then((resb) => {
                                  if (resb.data.code == 200) {
                                    for (let items of resb.data.result.list) {
                                      items.label = items.name
                                      items.value = items.id + ''
                                    }
                                    c.sources = resb.data.result.list
                                  }
                                })
                              }
                            }
                          }
                          // 群组
                          if (item.attr === 'group') {
                            item.relationOptions = []
                            await this.getGroup(item)
                          }
                          // 标签也就是客户画像
                          if (item.attr === 'aud_portary') {
                            // 标签
                            if (item.selectedOptions[1].split('@')[0] === 'tag') {
                              item.relationOptions = [
                                {
                                  value: 'contain',
                                  label: '包含'
                                }, {
                                  value: 'not_contain',
                                  label: '不包含'
                                }, {
                                  value: 'empty',
                                  label: '为空'
                                },
                                {
                                  value: 'not_empty',
                                  label: '不为空'
                                }
                              ]
                            }
                          }
                          // 标签也就是客户画像
                          if (item.attr === 'customer_kpi') {
                            // 标签
                            item.relationOptions = [
                              {
                                value: 'equal',
                                label: '等于'
                              },
                              {
                                value: 'not_equal',
                                label: '不等于'
                              },
                              {
                                value: 'gt',
                                label: '大于'
                              },
                              {
                                value: 'lt',
                                label: '小于'
                              },
                              {
                                value: 'gtele',
                                label: '区间'
                              }
                            ]
                          }
                        }
                      }
                      setTimeout(() => {
                        this.forSonTerms = JSON.parse(JSON.stringify(query.termsGroup))
                        this.allRelationship = query.allRelationship
                        this.allTerms.allRelationship = query.allRelationship
                        this.allTerms.termsGroup = this.forSonTerms
                      }, 2000)
                    }
                  })
                }
              })
            }
          })
        } else {
          // 静态群组
          getAudListShowSix(modelId).then((audListShowSixRes) => {
            if (audListShowSixRes.data.code == 200) {
              getCusAttrList(modelId).then((resp) => {
                if (resp.data.code == 200) {
                  let data = resp.data.result
                  let normal = []
                  let notNormal = []
                  for (let attr of data) {
                    if (attr.isNormal === 0) {
                      notNormal.push(attr)
                    } else {
                      normal.push(attr)
                    }
                  }
                  // 总的设置列属性
                  let arr = JSON.parse(audListShowSixRes.data.result.fields)
                  for (let a of arr) {
                    for (let item of normal) {
                      if (item.identity === a.identity) {
                        a.name = item.name
                      }
                    }
                  }
                  // 处理发给后台的表头
                  for (let one of arr) {
                    if (one.isChecked === 1) {
                      rowList.push(one)
                    }
                  }
                  console.log('zhensjide', rowList)
                  getAudGroupDetail(id, '', '', 1, 10, 1, rowList, modelId).then((res) => {
                    if (res.data.code == 200) {
                      this.group_id = res.data.result.groupId
                      this.newGroupName = res.data.result.name
                    }
                  })
                }
              })
            }
          })
        }
      }
    },
    // 数据加载时的动画
    openLoading () {
      setTimeout(() => {
        this.loading = false
      }, 500)
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      // 判断是不是safari浏览器
      let userAgent = window.navigator.userAgent // 取得浏览器的userAgent字符串
      if (/Safari/.test(userAgent) && !/Chrome/.test(userAgent)) {
        vm.isSafari = true
      } else {
        vm.isSafari = false
      }
      vm.getAudGroupGroupLists(to.params.id, to)
      vm.getAudiencesName(to.params.id, to)
      // vm.loadSix(to.params.id)
      vm.editWhat()
    })
  },
  beforeRouteUpdate (to, from, next) {
    // 判断是不是safari浏览器
    let userAgent = window.navigator.userAgent // 取得浏览器的userAgent字符串
    if (/Safari/.test(userAgent) && !/Chrome/.test(userAgent)) {
      this.isSafari = true
    } else {
      this.isSafari = false
    }
    this.getAudGroupGroupLists(to.params.id, to)
    this.getAudiencesName(to.params.id, to)
    // this.loadSix(to.params.id)
    this.editWhat()
    next()
  },
  created () {
    // this.load()
    this.editWhat()
  }
}
</script>

<style scoped>
.name-wrapper {
  overflow: hidden; /*超出部分隐藏*/
  white-space: nowrap; /*不换行*/
  text-overflow: ellipsis; /*超出部分文字以...显示*/
}
@media only screen and (max-width: 1450px) {
  .text-align-right .fold-button-content {
    display: none;
  }
  .text-align-right .dropdown-btn-content {
    display: inline-block;
  }
}
.fold-button-content {
  float: right;
  display: inline-block;
}
.dropdown-btn-content {
  display: none;
}
.el-menu-item .menu-btn {
  display: none;
  float: right;
}
.el-menu-item:hover .menu-btn {
  display: block;
}
.disabled {
  background: #ccc !important;
}
.getIt {
  color: #ff5500 !important;
}
.cancelCreate {
  float: right;
  margin-right: 10px;
  color: #ff7373;
  cursor: pointer;
}
.el-menu-vertical-demo {
  position: relative;
}
.group-search {
  height: 60px;
  background: #fff;
  border-bottom: 1px solid #e5e5e5;
}
.el-radio-group {
  margin-top: -13px;
}
.text-align-left {
  text-align: left;
}
.text-align-right {
  text-align: right;
}
.table-title {
  text-align: left;
}
/*  .search-title{
    background:#ecf6ff;
    border:1px solid #ebebeb;
    height:60px;
    padding:10px;
    line-height: 40px;
  }*/
::-webkit-scrollbar {
  width: 6px; /*滚动条宽度*/
  height: 16px; /*滚动条高度*/
}
/*定义滚动条轨道 内阴影+圆角*/
::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  border-radius: 10px; /*滚动条的背景区域的圆角*/
  background-color: #f5f5f5; /*滚动条的背景颜色*/
}
/*定义滑块 内阴影+圆角*/
::-webkit-scrollbar-thumb {
  border-radius: 10px; /*滚动条的圆角*/
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #ccc; /*滚动条的背景颜色*/
}
.el-dropdown-link {
  display: inline-block;
  background-color: #1890FF;
  height: 30px;
  line-height: 30px;
  text-align: center;
  width: 92px;
  border-radius: 20px;
  color: #fff;
  outline: none;
  margin-right: 10px;
  cursor: pointer;
}
</style>
